export default __webpack_public_path__ + "static/media/filter-icon.8276b0c5.svg";